/*
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-03-25 14:29:15
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-12-08 14:51:23
 * @FilePath: \lightning\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
// import App from './App.vue';

// https://www.moodsci.com/SWDataservice/interface/v1/api
// http://10.228.202.140:8080/SWDataservice/interface/v1/api
// import * as L from 'leaflet'
import 'leaflet.pm'
import 'leaflet.pm/dist/leaflet.pm.css'
import 'leaflet/dist/leaflet.css'
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$url = 'https://www.moodsci.com/SWDataservice/interface/v1/api'
// Vue.prototype.$url = '/api/SWDataservice/interface/v1/api'
// Vue.prototype.$url = 'http://10.228.202.140:8080/SWDataservice/interface/v1/api'
Vue.prototype.$sendurl = 'http://120.79.183.250:3098'
// Vue.prototype.$sendurl = 'http://10.228.202.140:3099'
// axios.defaults.baseURL ='https://www.moodsci.com/';
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
